/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import config from "../../../config/config"
import { useSelector } from 'react-redux';
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import axios from "axios";

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import DashboardSection from '../../DashboardContainer/DashboardSection';
import DomainTile from '../../DomainTile/DomainTile';
import ReusableTable from '../../ReusableTable/ReusableTable';
import styles from './AgratasBankReconciliation.module.css';

const WeekOptions = [
  { value: 'undefined', label: 'Select' },
  { value: 'All', label: '-All-' },
  ...Array.from({ length: 52 }, (_, i) => ({
    value: `W${i + 1}`,
    label: `Week ${i + 1}`
  }))
];

const { API_BASE_URL } = config;

const AgratasTimeLiness = () => {

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const initialFilters = location.state || {
    regionData: [],
    yearData: [],
    monthData: [],
  };

  const [hasApplied, setHasApplied] = useState(false);

  const [filters, setFilters] = useState(initialFilters);

  const [regionOptions, setRegionOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [monthOptions, setMonthOptions] = useState([]);

  const [region, setRegion] = useState([]);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);

  const [week, setWeek] = useState(WeekOptions[0]);

  const [data, setData] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [scheduleTotalRecords, setScheduleTotalRecords] = useState(0);
  const [journalPage, setJournalPage] = useState(1);
  const [schedulePage, setSchedulePage] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const itemsPerPage = 100;
  const [selectedPage, setSelectedPage] = useState(1);

  const history = useHistory()

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '20px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '50px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const handleRegionChange = (selected) => {
    const updatedRegions = selected || [];
    setRegion(updatedRegions);
    setFilters(prev => ({ ...prev, regionData: updatedRegions }));
  };

  const handleYearChange = (selected) => {
    const updatedYears = selected || [];
    setYear(updatedYears);
    setFilters(prev => ({ ...prev, yearData: updatedYears }));
  };

  const handleMonthChange = (selected) => {
    const updatedMonths = selected || [];
    setMonth(updatedMonths);
    setFilters(prev => ({ ...prev, monthData: updatedMonths }));
  };

  const handleWeekChange = (selected) => {
    setWeek(selected);
    setFilters(prev => ({ ...prev, weekData: selected }));
  };

  const handleJournalPageChange = (page) => {
    setJournalPage(page);
    fetchAgratasJournalDrilldownData(page);
  };

  const handleSchedulePageChange = (page) => {
    setSchedulePage(page);
    fetchAgratasScheduleDrilldownData(page);
  };

  const handleApply = () => {
    // const regionFilterData = region?.map(r => r?.value) || [];
    const yearFilterData = year?.map(y => y?.value) || [];

    // if (!regionFilterData || regionFilterData.length === 0){
    //   showPopup({
    //       type: MESSAGE_TYPE.INFORMATION,
    //       contextText: MESSAGE_TYPE.INFORMATION,
    //       info: "Please select region.",
    //     });
    //   return;
    // }

    if (!yearFilterData || yearFilterData.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    setJournalPage(1);
    setSchedulePage(1);
    fetchAgratasJournalDrilldownData(1);
    fetchAgratasScheduleDrilldownData(1);
  };

  const fetchAgratasJournalDrilldownData = async (page = journalPage) => {
    setdataLoading(true);
    try {
      const regionFilterData = region?.map(r => r?.value) || [];
      const yearFilterData = year?.map(y => y?.value) || [];
      const monthFilterData = month?.map(m => m?.value) || [];

      const limit = itemsPerPage;
      const offset = (page - 1) * limit;

      const response = await axios.post(`${API_BASE_URL}/api/journal-drilldown`, {
        region: regionFilterData,
        year: yearFilterData,
        month: monthFilterData,
        limit: limit,
        offset: offset
      },
        {
          headers:
          {
            Authorization: "Basic YWRtaW4xOjEyMw=="
          },
        }
      );

      setData(response.data.data);
      setTotalRecords(response.data.total);
    } catch (error) {
      console.error("Error fetching Journal Drilldown data:", error);
    } finally {
      setdataLoading(false);
    }
  };

  const fetchAgratasScheduleDrilldownData = async (page = schedulePage) => {
    setdataLoading(true);
    try {
      const regionFilterData = region?.map(r => r?.value) || [];
      const yearFilterData = year?.map(y => y?.value) || [];
      const monthFilterData = month?.map(m => m?.value) || [];

      const limit = itemsPerPage;
      const offset = (page - 1) * limit;

      const response = await axios.post(`${API_BASE_URL}/api/schedules-drilldown`, {
        region: regionFilterData,
        year: yearFilterData,
        month: monthFilterData,
        limit: limit,
        offset: offset
      },
        {
          headers: {
            Authorization: "Basic YWRtaW4xOjEyMw=="
          },
        }
      );

      setScheduleData(response.data.data);
      setScheduleTotalRecords(response.data.total);
    } catch (error) {
      console.error("Error fetching Schedule Drilldown data:", error);
    } finally {
      setdataLoading(false);
    }
  };

  // const handleCSVDownload = () => {
  //   const csvHeader = columnsTable1.map(col => col.header).join(',');
  //   const csvRows = data.map(row =>
  //     columnsTable1.map(col => `"${(row[col.accessor] || '').replace(/"/g, '""')}"`).join(',')
  //   );
  //   const csvContent = [csvHeader, ...csvRows].join('\n');
  //   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(blob);
  //   link.download = 'Timeliness_of_Journal_Enteries_and_Asset_Capitalization.csv';
  //   link.click();
  // };

  // const handleCSVDownloads = () => {
  //   const csvHeader = columnsTable2.map(col => col.header).join(',');
  //   const csvRows = scheduleData.map(row =>
  //     columnsTable2.map(col => `"${(row[col.accessor] || '').replace(/"/g, '""')}"`).join(',')
  //   );
  //   const csvContent = [csvHeader, ...csvRows].join('\n');
  //   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(blob);
  //   link.download = 'Timeliness_Of_Schedules.csv';
  //   link.click();
  // };

  const handleCSVDownload = async () => {
    const regionFilterData = region?.map(r => r?.value) || [];
    const yearFilterData = year?.map(y => y?.value) || [];
    const monthFilterData = month?.map(m => m?.value) || [];
    const response = await axios.post(`${API_BASE_URL}/api/journal-drilldown`,
      {
        region: regionFilterData,
        year: yearFilterData,
        month: monthFilterData,
        limit: totalRecords,
        offset: 0,
      },
      {
        headers: {
          Authorization: "Basic YWRtaW4xOjEyMw==",
        },
      }
    );

    const fullData = response.data.data || [];

    const csvHeader = columnsTable1.map(col => col.header).join(',');
    const csvRows = fullData.map(row =>
      columnsTable1.map(col => `"${(row[col.accessor] ?? '').toString().replace(/"/g, '""')}"`).join(','));
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Timeliness_of_Journal_Enteries_and_Asset_Capitalization.csv';
    link.click();
  };

  const handleCSVDownloads = async () => {
    const regionFilterData = region?.map(r => r?.value) || [];
    const yearFilterData = year?.map(y => y?.value) || [];
    const monthFilterData = month?.map(m => m?.value) || [];
    const response = await axios.post(`${API_BASE_URL}/api/schedules-drilldown`,
      {
        region: regionFilterData,
        year: yearFilterData,
        month: monthFilterData,
        limit: scheduleTotalRecords,
        offset: 0,
      },
      {
        headers: {
          Authorization: "Basic YWRtaW4xOjEyMw==",
        },
      }
    );

    const allData = response.data.data || [];
    const csvHeader = columnsTable2.map(col => col.header).join(',');
    const csvRows = allData.map(row =>
      columnsTable2.map(col => `"${(row[col.accessor] ?? '').toString().replace(/"/g, '""')}"`).join(','));
    const csvContent = [csvHeader, ...csvRows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Timeliness_Of_Schedules.csv';
    link.click();
  };

  const handleReset = () => {
    setRegion([]);
    setYear([]);
    setMonth([]);
    setWeek(WeekOptions[0]);
    setFilters({
      regionData: [],
      yearData: [],
      monthData: [],
      weekData: null,
    });
  };

  const fetchRegionOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/Agratas-region`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setRegionOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching Agratas-region options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Agratas-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setYearOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching Agratas-year options:', error);
    }
  };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/Agratas-month`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setMonthOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching Agratas-month options:', error);
    }
  };

  useEffect(() => {
    fetchRegionOptions();
    fetchYearOptions();
    fetchMonthOptions();
  }, []);

  useEffect(() => {
    if (regionOptions.length && yearOptions.length && monthOptions.length) {

      if (filters.regionData && filters.regionData.length > 0) {
        const reg = regionOptions.filter(opt =>
          filters.regionData.some(m => m.value === opt.value)
        );
        if (reg.length > 0) setRegion(reg);
      }

      if (filters.yearData && filters.yearData.length > 0) {
        const yr = yearOptions.filter(opt =>
          filters.yearData.some(m => (m?.value ?? m) === opt.value)
        );
        if (yr.length > 0) setYear(yr);
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptions.filter(opt =>
          filters.monthData.some(m => m.value === opt.value)
        );
        if (mon.length > 0) setMonth(mon);
      }

      if (filters.yearData && filters.yearData.length > 0) {
        setTimeout(() => {
          setHasApplied(true);
        }, 1000);
      }
    }
  }, [regionOptions, yearOptions, monthOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const columnsTable1 = [
    { header: "Task Type", accessor: "task_type" },
    { header: "Request ID", accessor: "request_id" },
    { header: "Description", accessor: "description" },
  ];

  const columnsTable2 = [
    { header: "Sr. No.", accessor: "S.No" },
    { header: "Area", accessor: "area" },
    { header: "Name of Schedule", accessor: "name_of_schedule" },
    { header: "IN", accessor: "india" },
    { header: "GB", accessor: "gb" },
    { header: "US", accessor: "usa" },
  ];

  const [dataLoading, setdataLoading] = useState(false);

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Region</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={region}
                onChange={handleRegionChange}
                options={regionOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Year<span style={{ color: 'red' }}>*</span></label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptions}
                isSearchable={true}
                styles={customStyles}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
          {/* <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Week</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={week}
                onChange={setWeek}
                options={WeekOptions}
                isSearchable={true}
                styles={customStyles}
                isMulti={true}
                closeMenuOnSelect={false}
              />
            </div>
          </div> */}
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>
      <div>
        {/*First Table  */}
        <div className="row" >
          <div className="col-md-12">
            <DomainTile title='Timeliness' showBackButton={true} mainPagePath="/Record-To-Report/Agratas" detailState={filters} />
          </div>
        </div>
        <div className="row mt-2" >
          <div className="col-md-12">
            <DomainTile title='Timeliness of Journal Entries and Asset Capitalization' showBackButton={false} mainPagePath="/Record-To-Report/Agratas" detailState={filters} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              <ReusableTable
                data={data}
                columns={columnsTable1}
                itemsPerPage={itemsPerPage}
                onPageChange={handleJournalPageChange}
                isCustomOpen={true}
                totalRecords={totalRecords}
                handleCSVDownload={handleCSVDownload}
                dataLoading={dataLoading}
              />
            </DashboardSection>
          </div>
        </div>

        {/*Second Table  */}
        <div className="row mt-4" >
          <div className="col-md-12">
            <DomainTile title='Timeliness of Schedules' showBackButton={false} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DashboardSection title="" disableDetailView={true}>
              <ReusableTable
                data={scheduleData}
                columns={columnsTable2}
                itemsPerPage={itemsPerPage}
                onPageChange={handleSchedulePageChange}
                isCustomOpen={true}
                totalRecords={scheduleTotalRecords}
                handleCSVDownload={handleCSVDownloads}
                dataLoading={dataLoading}
              />
            </DashboardSection>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgratasTimeLiness;